import React from 'react'

import useStyles from './scroll-up-button.style'

import { useDispatch, useSelector } from 'react-redux'
import { selectShowScrollIndicator } from '@selectors'
import { SCROLL_TO_UNREAD } from '@redux/actions/types'

import Icon from '@components/icon/icon.component'

import { INDICATOR_SCROLL } from '../../assets/i18n/strings'
import i18n from 'i18n-js'

const ScrollUpButton = props => {
  const classes = useStyles(props)
  const dispatch = useDispatch()
  const Analytics = useSelector(state => state.analytic.analytics)

  const showScrollIndicator = useSelector(selectShowScrollIndicator)
  if (!showScrollIndicator) return null

  const onClick = e => {
    e.preventDefault()

    Analytics.logEvent('ViewUnreadTap')

    dispatch({
      type: SCROLL_TO_UNREAD,
      payload: true
    })
  }

  return (
    <div
      className={classes.container}
      data-testid='scroll-up-pill'
    >
      <button
        className={classes.contentContainer}
        onClick={onClick}
      >
        <span>{i18n.t(INDICATOR_SCROLL)}</span>
        <Icon type='arrow-up' />
      </button>
    </div>
  )
}

export default ScrollUpButton
